import LogSelectedNodeButton from "./LogSelectedNodeButton";
import NodeBoundsContextWrapper from "./NodeBoundsContextWrapper";
import { useMemo, useContext, useCallback, useRef, createContext, useState } from 'react';
import { useDispatch, useStore, useSelector } from 'react-redux';
import { createStore } from 'redux';
import { TemporaryCellValueRefContext, TemporaryCellValueContext } from './TemporaryCellValueProvider';
import A from './ActionCreators';
import G from './Getters';

import deepFreeze from './deepFreeze';
import { SelectedItemsContext } from './Contexts';

export const SelectedItemsDispatch = createContext();
export const SelectedItemsRefContext = createContext();
export const SelectedItemInfo = createContext({});
export const SelectedItemInfoRef = createContext();

function nothingSelected(items){

  if( !items ){
    return true;
  }

  let somethingSelected =  Object.values(items).some(y => y && y.length > 0);

  return !somethingSelected;

}

function simpleReducer(state,{type,newState={}}){



  return newState;
}

function dispatchBeforeSettingHookToEnsureNodeWrapperComponentCanAccessUpdatedStoreWhenSelectedHookIsChanged({resolvedValue,selectionTriggerItem,__setSelectedItems,
  selectedItemStore,
}){

  selectedItemStore.dispatch({type:"set",newState:{
      ...resolvedValue,
      selectionTriggerItem,
    }});
  
  __setSelectedItems(resolvedValue);


}

export default function SelectedItemProvider({figurePanelId, children,cellValueInputRef, onSelectItem, shouldIgnore }){


  const selectedItemStore = useMemo(() => {
    return createStore(simpleReducer,{
      expansionNodes:[{nodeId:"A",cellLocation:[2,1]}]
    })
  },[]);


  const dispatch = useDispatch();
  const temporaryCellValueRef = useContext(TemporaryCellValueRefContext);
  const temporaryCellValueContext = useContext(TemporaryCellValueContext);

  const setTemporaryCellValue = temporaryCellValueContext?.setTemporaryCellValue;

  const [selectedItems,__setSelectedItems] = useState({})//{expansionNodes:[{nodeId:"1-scalebar",cellLocation:[2,1]}]});

  const selectedItemInfo = useSelector(state => {

    let possibleActions = G.getPossibleFigureEditorActions(state,{figurePanelId,selectedItems});

    let unifiedGroup = G.getUnifiedGroupFromItems(state,{figurePanelId,items:selectedItems});

    return {
      possibleActions,
      unifiedGroup,
    }
  })

  const selectedItemsRef = useRef(selectedItems);

  const setSelectedItems = useCallback((value,selectionTriggerItem) => {

    if( !selectionTriggerItem ){
    }


    if( shouldIgnore && shouldIgnore(value) ){
      return;
    }

    let curSelectedItems = selectedItemsRef.current;

    if( nothingSelected(value) && nothingSelected(curSelectedItems ) ){
      return;
    }


    //first, need to override the temporary cell values;
    //
    let temporaryCellValue = temporaryCellValueRef.current;


    let selectedCells = selectedItemsRef.current?.cells;
    let cellsAreSelected = selectedCells?.length > 0;



    let tempValueNotNullish = temporaryCellValue!==null && temporaryCellValue!==undefined;

    if( tempValueNotNullish && cellsAreSelected ){

      console.log("There's a temp cell value... and cells are selected.");

      dispatch(A.setCellsValue({
        figurePanelId,
        cells:selectedCells,
        value:temporaryCellValue
      }))

      setTemporaryCellValue(null);

    }

    let resolvedValue = value || {};


    dispatchBeforeSettingHookToEnsureNodeWrapperComponentCanAccessUpdatedStoreWhenSelectedHookIsChanged({
      resolvedValue,
      selectionTriggerItem,
      __setSelectedItems,
      selectedItemStore,
    })
    

        
    selectedItemsRef.current = resolvedValue;


    
    if( cellsAreSelected ){
      if( cellValueInputRef && cellValueInputRef.current ){
        console.log("FOCUSING!");
        cellValueInputRef.current.focus();
      }
    }


  },[
    temporaryCellValueRef,
    figurePanelId,
    dispatch,cellValueInputRef,setTemporaryCellValue,
    
  ])


  useCallback(() => {
    setSelectedItems()
  },[figurePanelId])


  let frozenSelectedItemInfo = deepFreeze(selectedItemInfo);
  const selectedItemInfoRef = useRef(frozenSelectedItemInfo);
  selectedItemInfoRef.current = frozenSelectedItemInfo;


  return (
    <SelectedItemsDispatch.Provider value={setSelectedItems}>
      <SelectedItemsContext.Provider value={selectedItems}>
        <SelectedItemsRefContext.Provider value={selectedItemStore}>
          <SelectedItemInfo.Provider value={selectedItemInfo}>
            <SelectedItemInfoRef.Provider value={selectedItemInfoRef}>
              <NodeBoundsContextWrapper>

              {false && <div style={{
                position:'fixed',
                bottom:0,
                left:0,
                width:800,
                height:200,
                background:'black',
                color:'cyan',
                zIndex:100,
              }}>
                <div class="sg-row">
                  {Object.entries({selectedItems,selectedItemInfo}).map(([key,value]) => {
                    return (<button onClick={() => console.log(value)}>{`Log ${key}`}</button>);
                  })}
                  <LogSelectedNodeButton/>
                  
                </div>


                

                  </div>}
            {children}
              </NodeBoundsContextWrapper>
            </SelectedItemInfoRef.Provider>
          </SelectedItemInfo.Provider>
        </SelectedItemsRefContext.Provider>
      </SelectedItemsContext.Provider>
    </SelectedItemsDispatch.Provider>
  )






}
